import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const BusinessContext = createContext({ businesses: [], active: "farm", setActive: () => {} });

const STORAGE_KEY = "acrelatch.active_business";

export function BusinessProvider({ children }) {
  const [businesses, setBusinesses] = useState([]);
  const [active, setActiveState] = useState(() => localStorage.getItem(STORAGE_KEY) || "farm");

  useEffect(() => {
    api.get("/businesses").then((r) => setBusinesses(r.data)).catch(() => {});
  }, []);

  const setActive = (id) => {
    setActiveState(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const activeBusiness = businesses.find((b) => b.id === active);

  return (
    <BusinessContext.Provider value={{ businesses, active, activeBusiness, setActive }}>
      {children}
    </BusinessContext.Provider>
  );
}

export const useBusiness = () => useContext(BusinessContext);
